import PropTypes from 'prop-types';

import { getContent } from '@/utils/helper';

import Text from '@/atoms/Text/Text';
import Question from '@/molecules/Question/Question';

export default function Faq({ fields, entries }) {
  const questions =
    fields?.question?.length > 0
      ? fields?.question.map((q) => getContent(q?.sys?.id, entries))
      : [];

  return (
    <div
      id={fields?.name}
      className={`aaco-faq container mx-auto mb-20
      flex flex-col
      py-6 md:py-[90px] dd-kr:md:py-0 dd-en:md:py-0 dd-en:md:mb-0 dd-kr:md:mb-0
      ${fields?.hasBackground ? 'bg-grey-1' : ''}`}
    >
      {fields?.title && (
        <Text tag="h6" style="mb-4">
          {fields.title}
        </Text>
      )}
      <Question questions={questions} entries={entries} />
    </div>
  );
}

Faq.propTypes = {
  fields: PropTypes.shape({
    hasBackground: PropTypes.bool,
    title: PropTypes.string,
  }),
  entries: PropTypes.array,
};
